import { useState } from 'react'
import * as Analytics from 'core/common/analytics'
import { countPromotions, parseNumber } from 'core/common/utils/formikHelpers'

const dialogState = {
  editConfirmed: false,
  oldValue: null,
}

const useConfirmWhenHasPromotion = ({ confirmChangeValue, product, value }) => {
  const [dialogOpen, setDialogOpen] = useState(null)
  const promotion_count = countPromotions(product)

  const handleChangeValue = event => {
    const eventValue = parseNumber(event.target.value)

    if (value !== eventValue) {
      confirmChangeValue(eventValue)

      if (promotion_count && !dialogState.editConfirmed) {
        dialogState.oldValue = value
        setDialogOpen(event.target)
      }
    }
  }

  const handleClick = event => {
    if (promotion_count && !dialogState.editConfirmed && !event.target.disabled) {
      event.target.blur()
      dialogState.oldValue = value
      setDialogOpen(event.target)
    }
  }

  const onClose = () => {
    confirmChangeValue(dialogState.oldValue)
    setDialogOpen(null)
    Analytics.clickEventPromotion('nao-editar-preco')
  }

  const onConfirm = () => {
    dialogState.editConfirmed = true
    const input = dialogOpen
    setTimeout(() => input.focus(), 10)
    setDialogOpen(null)
    Analytics.clickEventPromotion('sim-editar-preco')
  }

  const isOpen = () => Boolean(dialogOpen)

  return { handleChangeValue, handleClick, onClose, onConfirm, isOpen, promotion_count }
}

export const usePromotionContinueDialog = ({ product, onContinue }) => {
  const [dialogOpen, setDialogOpen] = useState(false)
  const promotion_count = countPromotions(product)

  const handleClick = () => {
    if (promotion_count && !dialogState.editConfirmed) {
      setDialogOpen(true)
    } else {
      onContinue()
    }
  }

  const onClose = () => {
    setDialogOpen(false)
    Analytics.clickEventPromotion('nao-editar-preco')
  }

  const onConfirm = () => {
    dialogState.editConfirmed = true
    setDialogOpen(false)
    Analytics.clickEventPromotion('sim-editar-preco')
    onContinue()
  }

  const isOpen = () => dialogOpen

  return { handleClick, onClose, onConfirm, isOpen, promotion_count }
}

export default useConfirmWhenHasPromotion
